define('Cart.Item.Summary.View.CoreChargeItem', [
    'Cart.Item.Summary.View',
    'underscore',
    'cart_item_summary_core_charge_item.tpl'
], function CartItemSummaryViewCoreChargeItem(
    CartItemSummaryView,
    _,
    cartItemSummaryTpl
) {
    'use strict';

    var viewPrototype = CartItemSummaryView.prototype;
    if (viewPrototype) {
        _.extend(viewPrototype, {
            template: cartItemSummaryTpl
        });
    }
});
